import { ITimeDataItem } from './algoInterface'
import { calMonthRepPattern } from './calRepPattern'
import { divTimeData } from './classifyTimeData'

/**
 * PV 데이터 1000 으로 나누고 옵션따라 세팅
 * @param {ITimeDataItem[]} PVData
 * @param {string} pvOpt
 * @returns {ITimeDataItem[]}
 */
export const calUsingPV = (
  PVData: ITimeDataItem[],
  pvOpt: string
): ITimeDataItem[] => {
  const tmpData = divTimeData(PVData, 1000)

  switch (pvOpt) {
    case 'aver':
      return calMonthRepPattern(tmpData, 'aver').repData

    case 'mid':
      return calMonthRepPattern(tmpData, 'mid').repData

    case 'mode':
      return calMonthRepPattern(tmpData, 'mode').repData

    case 'realTime':
    default:
      return tmpData
  }
}

export const deepCopyTimeDataArray = (
  items: ITimeDataItem[]
): ITimeDataItem[] => {
  return items.map((item) => deepCopyTimeDataItem(item))
}

const deepCopyTimeDataItem = (item: ITimeDataItem): ITimeDataItem => {
  const copy: ITimeDataItem = {
    date: item.date,
    value: item.value,
  }

  if ('season' in item) {
    if (item.season !== undefined) {
      copy.season = item.season
    }
  }

  if ('workDay' in item) {
    if (item.workDay !== undefined) {
      copy.workDay = item.workDay
    }
  }

  if ('loadTime' in item) {
    if (item.loadTime !== undefined) {
      copy.loadTime = item.loadTime
    }
  }

  if ('hour' in item) {
    if (item.hour !== undefined) {
      copy.hour = item.hour
    }
  }

  if ('month' in item) {
    if (item.month !== undefined) {
      copy.month = item.month
    }
  }

  if ('day' in item) {
    if (item.day !== undefined) {
      copy.day = item.day
    }
  }

  return copy
}
